<template>
  <div class="not-found-error h-center-align">
    <h1>Oops!</h1>
    <h3>The {{ resource }} you're looking for is not here.</h3>
  </div>
</template>

<script>
  export default {
    props: {
      resource: {
        type: String,
        required: true,
        default: 'item',
      },
    },
  };
</script>
